import React from 'react';
import { connect } from 'react-redux';
import { maxBy, isEqual } from 'lodash';
import ReactTable from "react-table";
import CSV from '../../../helpers/CSVExport';
import ReactSelect from '../../common/ReactSelect';

import config from '../../../config/config';
import Box from '../../common/Box';
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
import { tracksActions } from '../../../data/actions/tracks';
import { BarChart, LineChart} from '../../widgets/charts/types';
import { splitByThousands } from '../../../helpers/NumberFormatter';

class DemographicsStats extends React.Component {
    
    constructor(props) {
        super(props);
        this.exportToCsv = this.exportToCsv.bind(this);        
    }
    
    exportToCsv(){
        const { tracks, id }  = this.props,
            exportData = tracks.demographicsComparison[id].data;        
        const filename = CSV.CSVHeader(`track-comparison-demographics`, id);
        return CSV.CSVExport(exportData, {filename}, 'track-comparison-demographics');
    }

    renderToolbar(){
        let toolbar = [];
        toolbar.push(<div key="wrapper" className="ibox-action-holder">
        <div className="ibox-actions">
          <a key="download" title="Export CSV" onClick={this.exportToCsv} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
        </div>
        </div>)
        return toolbar;
    }


    componentDidMount() {
        const { id, weeks, territories, vendors, metadata } = this.props,
            releaseDate = metadata.release_date;
        this.props.dispatch(tracksActions.compareTrackDemographics(id, weeks, releaseDate, territories, vendors))
        
    }
    
    componentWillReceiveProps(nextProps) {
    }
    
    render (){
        const { tracks, id, metadata, chartID = '' }  = this.props,
            chartData = tracks.demographicsComparison[id];

        const title = ( metadata && metadata.name_compare ) ? metadata.name_compare : id;
        return <Box title={title} spinnerEnabled={tracks.demographicsComparisonLoading} toolbar={this.renderToolbar()}>
        
            {chartData && <div className="row">
                <div className={`col-xs-12`}>
                    {chartData.datasets.length > 0 && <div className="chart-block">
                        <BarChart data={chartData} id={chartID} options={{
                            legend: {display: true, labels: {usePointStyle: true}}, 
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    stacked: true,
                                    ticks: {
                                        callback: function(value, index, values) {
                                            return splitByThousands(value);
                                        }
                                    }

                                }],
                                yAxes: [{
                                    stacked: true,
                                    ticks: {
                                        callback: function(value, index, values) {
                                            return splitByThousands(value);
                                        }
                                    }                                    
                                }]
                            },
                            tooltips: {
                                callbacks: {
                                    label: function(tooltipItem, data) {
                                        return splitByThousands(tooltipItem.yLabel);
                                    }
                                }
                            }
                            
                        }} />                          
                    </div>}
                    {!chartData.datasets.length && <p>No data available</p>}
                </div>    
            </div>}
        </Box>
    }
}

function mapStateToProps(state) {
    return {
        tracks: state.tracks,
        filter: state.filter,
        userData: state.user
    } 
}

export default connect(mapStateToProps)(DemographicsStats);